export const formRules = {
  required: (v: string) => !!v || "Thông tin bắt buộc",
  minLength: (v: string) => v.length >= 6 || "Mật khẩu phải có ít nhất 6 ký tự",
  isEmail: (v: string) => /.+@.+\..+/.test(v) || "Định dạng email không đúng",
};
